import { CSSProperties, FC, PropsWithChildren, ReactNode } from 'react'
import Truncate from '../../Truncate'
import { Link } from 'react-router-dom'
import TooltipWrapper from '../../common/TooltipWrapper'

const ButtonLink: FC<
  PropsWithChildren<{
    onClick?: () => unknown
    to?: string
    target?: string
    truncate?: boolean
    className?: string
    style?: CSSProperties
    tooltip?: string
    variant?: 'primary' | 'delete'
  }>
> = ({
  children,
  to,
  onClick,
  truncate,
  target,
  className,
  style = {},
  tooltip = '',
  variant = 'primary',
}) => {
  const options = {
    onClick,
    className: [
      'flex items-center underline transition duration-300 underline-offset-4',
      {
        primary: 'text-primary hover:text-primary_hover',
        delete: 'text-red-600 hover:text-red-500',
      }[variant],
      className,
    ].join(' '),
  }

  const content = !!truncate ? <Truncate>{children}</Truncate> : children

  const button: ReactNode = to ? (
    <Link
      to={to}
      {...(target ? { target } : {})}
      {...options}
      style={style}
    >
      {content}
    </Link>
  ) : (
    <div
      tabIndex={-1}
      role='button'
      {...options}
      style={style}
    >
      {content}
    </div>
  )

  return tooltip ? <TooltipWrapper content={tooltip}>{button}</TooltipWrapper> : button
}

export default ButtonLink
